import React from 'react';
import './App.css';
import BackTop from './assets/back-top.svg'

const BackToTopButton = () => {
  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <img src={BackTop} className="back-to-top" onClick={handleScrollToTop}  alt="back to top button"/>
    
  );
};

export default BackToTopButton;
